import { render, staticRenderFns } from "./AdminTools.vue?vue&type=template&id=366e0de3&"
import script from "./AdminTools.vue?vue&type=script&lang=js&"
export * from "./AdminTools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports